import { downloadMultipleDataAsCsv, Dataset } from '../../../utils/downloadHelpers';
import { Link } from '@heroui/react';
import { LuDownload } from 'react-icons/lu';

interface MultiChartDownloadButtonProps<T extends Record<string, any>> {
	datasets: Dataset<T>[];
	filename: string;
	className?: string;
	iconOnly?: boolean;
	buttonStyle?: 'primary' | 'secondary' | 'text';
	buttonText?: string;
}

export function MultiChartDownloadButton<T extends Record<string, any>>({
	datasets,
	filename,
	className = '',
}: MultiChartDownloadButtonProps<T>) {
	const handleDownload = () => {
		if (datasets && datasets.length > 0) {
			downloadMultipleDataAsCsv(datasets, filename);
		} else {
			console.warn('No chart datasets available to download');
		}
	};

	const hasValidData = datasets && datasets.some((dataset) => dataset.data && dataset.data.length > 0);

	return (
		<Link
			className={`${className} absolute cursor-pointer pr-2`}
			style={{ right: 40, top: 10 }}
			aria-label="Download all chart data as single CSV file"
			title="Download all chart data as single CSV file"
			onPress={handleDownload}
			isDisabled={!hasValidData}
		>
			<LuDownload color="#151B1E" size={16} className="bg-white rounded-none absolute" />
		</Link>
	);
}
